import React, { useState } from "react"
import { useSelector } from "react-redux"
import {
	Button,
	Input,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
} from "reactstrap"
import { sendEvent } from "../../../api/socket/functions"

function CommentModal() {
	const [isOpen, setIsOpen] = useState(false)
	const [inputedComment, setInputedComment] = useState("")

	const { isMatchDone } = useSelector((state) => {
		return {
			isMatchDone:
				state.penaltiesOrEnd === "done" ||
				state.penaltiesOrEnd === "forfeit",
		}
	})
	const onDone = () => {
		sendEvent({
			event: "Komentar",
			comment: inputedComment,
			eventKey: "comment",
		})
		dismissModal()
	}

	const dismissModal = () => {
		setIsOpen(false)
		setInputedComment("")
	}

	if (isMatchDone) {
		return <></>
	}

	return (
		<>
			<Button.Ripple
				color="flat-primary"
				size="sm"
				onClick={() => setIsOpen(true)}
			>
				Komentar
			</Button.Ripple>
			<Modal
				isOpen={isOpen}
				toggle={dismissModal}
				className="modal-dialog-centered"
			>
				<ModalHeader toggle={dismissModal}>Komentar</ModalHeader>
				<ModalBody>
					<p>Upiši svoj komentar u polje ispod</p>
					<Input
						type="text"
						onChange={({ target }) => {
							setInputedComment(target.value)
						}}
					/>
				</ModalBody>

				<ModalFooter>
					{inputedComment ? (
						<Button.Ripple color="primary" onClick={onDone}>
							Nastavi
						</Button.Ripple>
					) : (
						<></>
					)}
					<Button.Ripple color="secondary" outline onClick={dismissModal}>
						Odustani
					</Button.Ripple>
				</ModalFooter>
			</Modal>
		</>
	)
}

export default CommentModal
